import api from "./api";

export const getAllVehicles = async () => {
  const res = await api.get("/VehicleDetails/GetVehicleDetails");
  if (Array.isArray(res?.data)) return res.data;
  return res?.data?.resultSet || [];
};

export const postUpdateVehicleStatus = async (vehicleObj) => {
  const payload = [vehicleObj];
  const res = await api.post("/VehicleRegister/PostVehicleDetails", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateEmergency = async (vehicleId, eCode, eDescription) => {
  const payload = [
    {
      vehicleId,
      ecode: eCode,
      ediscription: eDescription,
    },
  ];

  const res = await api.post("/VehicleRegister/UpdateEmergency", payload, {
    headers: { "Content-Type": "application/json" },
  });

  return res.data;
};

export default {
  getAllVehicles,
  postUpdateVehicleStatus,
  updateEmergency,
};
